(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muna-science"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Keeps the page light:
       - waits until the page has finished loading and the browser is idle
       - only plays while the video is on screen (pauses when it scrolls away)
       - picks the light version (480p) for small boxes / slow connections, the sharp one (720p) otherwise
       - always plays, whatever the device settings */
    var conn = navigator.connection || {};
    var slow = /(^|-)(2g|3g)$/.test(conn.effectiveType || '');

    function pick(video) {
      var sd = video.getAttribute('data-muna-sd');
      var hd = video.getAttribute('data-muna-hd') || sd;
      var px = (video.parentElement ? video.parentElement.clientWidth : 0) * (window.devicePixelRatio || 1);
      return slow || px <= 680 ? sd || hd : hd;
    }

    /* Some phones (e.g. iPhone in low power mode) block autoplay until the visitor touches the page.
       When that happens, the video starts on the very first tap anywhere - no button needed. */
    var blocked = [];
    var armed = false;

    function retryBlocked() {
      var list = blocked.slice();
      blocked = [];
      list.forEach(function (v) { if (v.__munaInView) play(v); });
      if (!blocked.length) disarm();
    }

    function arm() {
      if (armed) return;
      armed = true;
      ['touchend', 'pointerup', 'click', 'keydown'].forEach(function (t) {
        document.addEventListener(t, retryBlocked, true);
      });
    }

    function disarm() {
      armed = false;
      ['touchend', 'pointerup', 'click', 'keydown'].forEach(function (t) {
        document.removeEventListener(t, retryBlocked, true);
      });
    }

    function play(video) {
      if (!video.getAttribute('src')) video.setAttribute('src', pick(video));
      video.muted = true;
      var p = video.play();
      if (p && p.catch) {
        p.catch(function () {
          if (blocked.indexOf(video) === -1) blocked.push(video);
          arm();
        });
      }
    }

    function observe() {
      var videos = document.querySelectorAll('.muna-science__video[data-muna-sd]:not([data-muna-ready])');
      if (!videos.length) return;
      if (!('IntersectionObserver' in window)) {
        videos.forEach(function (v) { v.setAttribute('data-muna-ready', ''); v.__munaInView = true; play(v); });
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            e.target.__munaInView = e.isIntersecting;
            if (e.isIntersecting) play(e.target);
            else if (!e.target.paused) e.target.pause();
          });
        },
        { rootMargin: '200px 0px' }
      );
      videos.forEach(function (v) { v.setAttribute('data-muna-ready', ''); io.observe(v); });
    }

    function whenIdle(fn) {
      if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2500 });
      else window.setTimeout(fn, 400);
    }

    function init() {
      if (document.readyState === 'complete') whenIdle(observe);
      else window.addEventListener('load', function () { whenIdle(observe); }, { once: true });
    }

    init();
    document.addEventListener('shopify:section:load', function () { whenIdle(observe); });
  })();

  } catch(e) { console.error(e); }
})();
})();
